import React from "react";
import "containers/Tribe/Friends/Home/MyFriends.css";
import AxiosConfig from "axiosConfig";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import FriendGroupChildrenToggle from "components/Tribe/FriendGroupChildrenToggle";
import GroupListContainer from "components/Tribe/Groups/GroupsHome/GroupListContainer";
import * as CONSTANT from "constants/text.js";
import NewGroupBanner from "components/Tribe/Groups/GroupsHome/NewGroupBanner";
import SearchNewUsers from "components/Tribe/Friends/FriendsHome/SearchNewUsers";
import FriendsSearchGrid from "components/Project/StartProject/Step_3/FriendsSearchGrid";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";
import TextTheme from "../../../../components/General/Text/TextTheme";

class MyGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: "",
      invitations: "",
      requests: "",
      groupsSearchData: [],
      searchType: "",
      searchValue: "",
      searchPage: 1,
      searchOrigin: CONSTANT.GROUPS_PAGE,
      searchMoreAvailable: true,
      searchLessAvailable: true,
    };
  }

  /*************
   * TODO: add more comments here when needed
   * When component loads in:
   * Get the the groups this user is a part of.
   * Get group invites received and invites sent
   */
  componentDidMount() {
    this.fetchMyGroups(this);
    this.fetchMyInvites(this);
    this.fetchMyRequests(this);
  }

  /******************************************************************
   * Get this users Groups
   */
  fetchMyGroups(obj) {
    AxiosConfig.get("groups/list/").then(function (response) {
      obj.setMyGroups(response);
    });
  }
  /**
   * Set this user's groups
   */
  setMyGroups(response) {
    this.setState((prevState) => ({
      groups: response.data,
    }));
  }

  /******************************************************************
   * Get this user's received invites
   */
  fetchMyInvites(obj) {
    AxiosConfig.get("groups/invitations/").then(function (response) {
      obj.setMyInvites(response);
    });
  }
  /**
   * Set this user's invites from groups
   */
  setMyInvites(response) {
    this.setState((prevState) => ({
      invitations: response.data,
    }));
  }

  /******************************************************************
   * Get this user's sent requests
   */
  fetchMyRequests(obj) {
    AxiosConfig.get("groups/requests/").then(function (response) {
      obj.setMyRequests(response);
    });
  }
  /**
   * Set this user's requests to groups
   */
  setMyRequests(response) {
    this.setState((prevState) => ({
      requests: response.data,
    }));
  }

  //ref containers/Projects/StartProject/Step_3/StartProjectStepThree.js
  fetchGroupsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchGroupsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag,
      this.props.groupId
    );
  }

  //ref containers/Projects/StartProject/Step_3/StartProjectStepThree.js
  fetchGroupsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchGroupsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag,
      this.props.groupId
    );
  }

  /*****************************************************************
   * main render method
   */
  render() {
    return (
      <div className="header_main main_friends">
        <div className="page_main main_page">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>
          <div className="page_details_main tribe">
            <div className="mb-15 friend_group_button">
              <FriendGroupChildrenToggle activeTab={CONSTANT.GROUPS} />
            </div>
            <NewGroupBanner history={this.props.history} />
            {/**************************INVITATIONS**********************************/}
            <div className="mt-15 page_details_content_main">
              <div className="textHeader">{CONSTANT.INVITATIONS}</div>
              {this.state.invitations && this.state.invitations.length > 0 ? (
                <GroupListContainer
                  groupLists={this.state.invitations}
                  type={CONSTANT.INVITATIONS}
                  history={this.props.history}
                  pageSize={6}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.NO_NEW_GROUP_INVITATIONS}
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
            </div>
            {/***************************REQUESTS***********************************/}
            <div className="mt-15 page_details_content_main">
              <div className="textHeader">{CONSTANT.REQUESTS}</div>
              {this.state.requests && this.state.requests.length > 0 ? (
                <GroupListContainer
                  groupLists={this.state.requests}
                  type={CONSTANT.REQUESTS}
                  history={this.props.history}
                  pageSize={6}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.NO_NEW_GROUP_REQUESTS}
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
            </div>
            {/***************************GROUPS***********************************/}
            <div className="mt-15 page_details_content_main">
              <div className="mb-15 title_search_header">
                <div className="textHeader">{CONSTANT.GROUPS}</div>
                <div className="friend_search_container">
                  <SearchNewUsers
                    searchResultHandler={FriendsSearchHelper.searchResultHandler.bind(
                      this
                    )}
                    placeholder={CONSTANT.FIND_NEW_GROUPS}
                  />
                </div>
              </div>
              {this.state.groups && this.state.groups.length > 0 ? (
                <GroupListContainer
                  groupLists={this.state.groups}
                  type={CONSTANT.GROUPS}
                  history={this.props.history}
                  pageSize={10}
                />
              ) : (
                <TextTheme
                  message={CONSTANT.NO_GROUP}
                  className="mt-15 mb-15 d-inline-block w-100 text_small text_med_grey text-center"
                />
              )}
            </div>
            {this.state.popupSearch ? (
              <FriendsSearchGrid
                searchData={this.state.groupsSearchData}
                searchStringType={this.state.searchType}
                searchStringValue={this.state.searchValue}
                searchMore={this.state.searchMoreAvailable}
                searchLess={this.state.searchLessAvailable}
                searchResultCancelClick={FriendsSearchHelper.searchResultCancelClick.bind(
                  this
                )}
                searchResultDoneClick={FriendsSearchHelper.searchResultDoneClick.bind(
                  this
                )}
                searchResultNextClick={FriendsSearchHelper.searchResultNextClick.bind(
                  this
                )}
                searchResultBackClick={FriendsSearchHelper.searchResultBackClick.bind(
                  this
                )}
                searchResultViewClick={FriendsSearchHelper.searchResultViewClick.bind(
                  this
                )}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default MyGroups;
